<template>
  <MglMarker
    :coordinates="[vessel.coordinates[0], vessel.coordinates[1]]"
    @click="onPressed(vessel)"
  >
    <div
      slot="marker"
      class="vessel-marker"
    >
      <div
        class="marker-icon-container"
        :style="{ background: showFoulingStatus ? vesselColor : defaultColor }"
      >
        <v-icon
          slot="marker"
          color="white"
          size="20"
        >
          mdi-ferry
        </v-icon>
      </div>
      <div class="marker-label">
        <span>{{ vessel.vessel }}</span>
      </div>
    </div>
  </MglMarker>
</template>

<script>
import { MglMarker } from "@/components/mapbox";

export default {
  name: "VesselMarker",
  components: {
    MglMarker,
  },
  props: {
    vessel: {
      type: Object,
      required: true,
    },
    onPressed: {
      type: Function,
      required: true,
    },
    showFoulingStatus: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    defaultColor() {
      // Default neutral color when fouling status is hidden
      return "linear-gradient(135deg, #667eea 0%, #764ba2 100%)";
    },

    vesselColor() {
      const fouling = this.vessel.fouling;

      // Define color gradients based on fouling level
      if (fouling === undefined || fouling === null) {
        // Default gray for unknown fouling
        return "linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%)";
      }

      if (fouling <= 1) {
        // Low fouling - Green gradient
        return "linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)";
      } else if (fouling <= 4) {
        // Low-medium fouling - Blue-green gradient
        return "linear-gradient(135deg, #3498db 0%, #2980b9 100%)";
      } else if (fouling <= 8) {
        // Medium fouling - Blue gradient
        return "linear-gradient(135deg, #f39c12 0%, #e67e22 100%)";
      } else if (fouling > 8) {
        // High fouling - Orange gradient
        return "linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)";
      } else {
        // Very high fouling - Red gradient
        return "linear-gradient(135deg, #95a5a6 0%, #7f8c8d 100%)";
      }
    },
  },
};
</script>

<style scoped>
.vessel-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vessel-marker:hover {
  transform: translateY(-2px);
}

.marker-icon-container {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 3px solid white;
  transition: all 0.3s ease;
  position: relative;
}

.marker-icon-container::before {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: inherit;
  border-radius: 50%;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.vessel-marker:hover .marker-icon-container {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
}

.vessel-marker:hover .marker-icon-container::before {
  opacity: 0.3;
}

.marker-label {
  margin-top: 2px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 4px 12px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.marker-label span {
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
  white-space: nowrap;
}

.fouling-status {
  margin-top: 2px;
  padding: 2px 6px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 8px;
  backdrop-filter: blur(5px);
}

.fouling-text {
  font-size: 10px !important;
  font-weight: 500 !important;
  color: white !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.vessel-marker:hover .marker-label {
  background: rgba(255, 255, 255, 1);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
